module.exports = __webpack_public_path__ + "assets/img/map-mylocation.b1c6e411.png";